// @ts-nocheck
import React, { FC } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number | string
}

const DefaultMapPin: FC<Props> = (props) => {
  const [primary300, primary400, primary800] = useToken('colors', ['primary.300', 'primary.400', 'primary.800'])

  const strokenWidth = '15px'
  const fillLight = useColorModeValue(primary400, primary300)
  const strokeDark = useColorModeValue(primary800, primary800)

  function getSize() {
    switch (props?.size) {
      case '2xs':
        return 'var(--chakra-sizes-2)'
      case 'xs':
        return 'var(--chakra-sizes-3)'
      case 'sm':
      default:
        return 'var(--chakra-sizes-4)'
      case 'md':
        return 'var(--chakra-sizes-6)'
      case 'lg':
        return 'var(--chakra-sizes-8)'
      case 'xl':
        return 'var(--chakra-sizes-12)'
      case '2xl':
        return 'var(--chakra-sizes-16)'
    }
  }

  return (
    <Box w={getSize()} h={getSize()} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 244.4 343">
        <g id="Camada_2" data-name="Camada 2">
          <g id="Camada_1-2" data-name="Camada 1">
            <path
              d="M122.78,7.5C84.74,7.5,7.5,31.71,7.5,117.59c0,74.38,91.3,191.22,111.4,216a5.06,5.06,0,0,0,7.83.05C146.84,309.53,236.9,197,236.9,117.59,236.9,28.25,159.67,7.5,122.78,7.5Zm2,170a58,58,0,1,1,58-58A58,58,0,0,1,124.76,177.5Z"
              fill={fillLight}
              stroke={strokeDark}
              strokeMiterlimit={10}
              strokeWidth={strokenWidth}
            />
            <path
              d="M94.76,295.5c34.55-16.19,64.73-54,75.53-70.18S204.84,153,204.84,110.87s-21.6-86.37-21.6-86.37h14.1L212.4,39.62,228.76,71.5l8,29v45l-14,36-25,51-27,44-31.33,35.33-14,24Z"
              fill="#000"
              opacity={0.2}
            />
            <path
              d="M126.73,333.67a5.06,5.06,0,0,1-7.83-.05C98.8,308.81,7.5,192,7.5,117.59,7.5,31.71,84.74,7.5,122.78,7.5c36.89,0,114.12,20.75,114.12,110.09C236.9,197,146.84,309.53,126.73,333.67Z"
              fill={'none'}
              stroke={strokeDark}
              strokeMiterlimit={10}
              strokeWidth={strokenWidth}
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

const generateDefaultMapPinSVG = (fillLight: string, strokeDark: string) => {
  const svgElement: React.ReactElement = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 244.4 343" width="244.4" height="343">
      <g id="Camada_2" data-name="Camada 2">
        <g id="Camada_1-2" data-name="Camada 1">
          <path
            d="M122.78,7.5C84.74,7.5,7.5,31.71,7.5,117.59c0,74.38,91.3,191.22,111.4,216a5.06,5.06,0,0,0,7.83.05C146.84,309.53,236.9,197,236.9,117.59,236.9,28.25,159.67,7.5,122.78,7.5Zm2,170a58,58,0,1,1,58-58A58,58,0,0,1,124.76,177.5Z"
            fill={fillLight}
            stroke={strokeDark}
            strokeMiterlimit={10}
            strokeWidth={'15px'}
          />
          <path
            d="M94.76,295.5c34.55-16.19,64.73-54,75.53-70.18S204.84,153,204.84,110.87s-21.6-86.37-21.6-86.37h14.1L212.4,39.62,228.76,71.5l8,29v45l-14,36-25,51-27,44-31.33,35.33-14,24Z"
            fill="#000"
            opacity={0.2}
          />
          <path
            d="M126.73,333.67a5.06,5.06,0,0,1-7.83-.05C98.8,308.81,7.5,192,7.5,117.59,7.5,31.71,84.74,7.5,122.78,7.5c36.89,0,114.12,20.75,114.12,110.09C236.9,197,146.84,309.53,126.73,333.67Z"
            fill={'none'}
            stroke={strokeDark}
            strokeMiterlimit={10}
            strokeWidth={'15px'}
          />
        </g>
      </g>
    </svg>
  )

  const markup = renderToStaticMarkup(svgElement)
  const base64 = window.btoa(unescape(encodeURIComponent(markup)))
  return `data:image/svg+xml;base64,${base64}`
}

export { DefaultMapPin, generateDefaultMapPinSVG }
